"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.OldPrice = exports.CurrentPrice = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1)
}));
const CurrentPrice = exports.CurrentPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  useOfferColor
}) => ({
  color: useOfferColor ? theme.palette.offer.main : theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold
}));
const OldPrice = exports.OldPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  textDecoration: 'line-through'
}));